import type { Template } from "@/types";

export const LA_05_H0_V5: Template[] = [
{
    id: "la-05-h0v5-01",
    name: "LA 01 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 88, y: 84, width: 214, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 84, width: 214, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 531, y: 84, width: 214, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 752, y: 84, width: 214, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 973, y: 84, width: 214, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-02",
    name: "LA 02 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 60, width: 249, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 256, y: 60, width: 249, height: 356, rotation: 0, imageRotation: 0 },
            { id: "3", x: 513, y: 60, width: 249, height: 356, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 60, width: 249, height: 356, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1025, y: 60, width: 249, height: 356, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-03",
    name: "LA 03 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 134, y: 170, width: 181, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 170, width: 181, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 170, width: 181, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 170, width: 180, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1054, y: 170, width: 180, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-04",
    name: "LA 04 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 139, y: 0, width: 361, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 754, y: 39, width: 283, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1043, y: 39, width: 111, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1043, y: 174, width: 111, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1043, y: 309, width: 111, height: 126, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-05",
    name: "LA 05 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 178, y: 46, width: 138, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 178, y: 242, width: 138, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 46, width: 137, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 242, width: 137, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 773, y: 0, width: 366, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-06",
    name: "LA 06 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 116, y: 48, width: 265, height: 384, rotation: 0, imageRotation: 0 },
            { id: "2", x: 388, y: 48, width: 136, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 388, y: 243, width: 136, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 84, width: 221, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 84, width: 220, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-07",
    name: "LA 07 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 123, y: 39, width: 277, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 406, y: 39, width: 108, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 406, y: 174, width: 108, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 406, y: 309, width: 108, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 39, width: 302, height: 396, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-08",
    name: "LA 08 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 177, y: 44, width: 283, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 810, y: 44, width: 141, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 810, y: 242, width: 141, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 44, width: 141, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 242, width: 141, height: 191, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-09",
    name: "LA 09 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 100, y: 42, width: 303, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 410, y: 42, width: 148, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 410, y: 241, width: 148, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 564, y: 42, width: 302, height: 391, rotation: 0, imageRotation: 0 },
            { id: "5", x: 874, y: 42, width: 302, height: 391, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h0v5-10",
    name: "LA 10 - H0V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h0_v5_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 100, y: 42, width: 303, height: 392, rotation: 0, imageRotation: 0 },
            { id: "2", x: 410, y: 42, width: 302, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 42, width: 302, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1028, y: 42, width: 148, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1028, y: 241, width: 148, height: 193, rotation: 0, imageRotation: 0 }
    ],
}
];